import React, { Component } from 'react';
import $ from 'jquery';
import uis from '../../../Common/css/ui.module.css';
import uneStyles from '../../../Common/css/uneCommon.module.css';

import { BeginOptionComponent } from '../../styled/sopPopupStyled';
import { i18n, withTranslation, i18nUtil } from '../../../language/i18n';

class BeginOption extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCurrent:true,
            year: null,
            month: null,
            day: null,
            hour: null,
            min: null,
            sec: null
        }

        this.props = props;        
    }

    componentDidMount() {
        //this.getDisasterCategories()
        $('html, body').css({ 'display': 'block', 'height': '100%', 'overflow': 'hidden' });
        $('.sqpDown').css({ 'color': '#000000' });
         //각 페이지 별로 클래스 초기화
        $('#subPage').removeClass('sop');

        this.setCurrentDate();
    }

    setCurrentDate = () => {
        const now = new Date();

        const year = now.getFullYear();
        const month = now.getMonth();
        const day = now.getDate();
        const hour = now.getHours();
        const min = now.getMinutes();
        const sec = now.getSeconds();

        this.setState({ year: year, month: month, day: day, hour: hour, min: min, sec: sec });
    }

    onChangeTimeMode(isCurrent) {
        if (isCurrent) {
            this.setCurrentDate();
        }

        this.setState({ isCurrent });
    }

    setDateTime() {
        if (this.state.year === null) {
            return [[], [], [], [], []];
        }

        let yearTag = [];        
        for (let i = this.state.year - 1; i <= this.state.year + 1; i++) {

            if (this.state.year === i) {
                yearTag.push(<option key={'year_' + i} value={i} defaultValue>{i}</option>);
            }
            else {
                yearTag.push(<option key={'year_' + i} value={i}>{i}</option>);
            }
        }
        
        let monthTag = [];
        for (let i = 0; i <= 11; i++) {
            if (this.state.month === i) {
                monthTag.push(<option key={'month_' + i + 1} value={i} defaultValue>{i + 1}</option>);
            }
            else {
                monthTag.push(<option key={'month_' + i + 1} value={i}>{i + 1}</option>);
            }
        }
                
        const lastDay = new Date(this.state.year, this.state.month, 0).getDate();
        let dayTag = [];
        for (let i = 1; i <= lastDay; i++) {
            if (this.state.day === i) {
                dayTag.push(<option key={'day_' + i} value={i} defaultValue>{i}</option>);
            }
            else {
                dayTag.push(<option key={'day_' + i} value={i}>{i}</option>);
            }
        }

        let hourTag = [];
        for (let i = 0; i <= 23; i++) {
            if (this.state.hour === i) {
                hourTag.push(<option key={'hour_' + i} value={i} defaultValue>{i}</option>);
            }
            else {
                hourTag.push(<option key={'hour_' + i} value={i}>{i}</option>);
            }
        }

        let minTag = [];
        for (let i = 0; i <= 59; i++) {
            if (this.state.min === i) {
                minTag.push(<option key={'min_' + i} value={i} defaultValue>{i}</option>);
            }
            else {
                minTag.push(<option key={'min_' + i} value={i}>{i}</option>);
            }
        }

        return [yearTag, monthTag, dayTag, hourTag, minTag];
    }

    onClickBegin = () => {
        
        const position = document.getElementById('txtPosition').value;
        if (!position || position.length === 0) {
            alert(i18n.t('sopSimulator.formText.재난 발생 위치를 입력하세요'));
            return;
        }
        else if (position.length > 50) {
            alert(i18n.t('sopSimulator.formText.재난 발생 위치 길이는 50자를 초과할 수 없습니다. (현재:') + position.length + ')');
            return;
        }
        else {
            let beginTime = '';
            if (this.state.isCurrent) {
                //const now = new Date();

                //const year = now.getFullYear();
                //const month = now.getMonth();
                //const day = now.getDate();
                //const hour = now.getHours();
                //const min = now.getMinutes();
                //const sec = now.getSeconds();

                beginTime = null;//new Date(year, month, day, hour, min, sec);
            }
            else {
                beginTime = new Date(this.state.year, this.state.month, this.state.day, this.state.hour, this.state.min, 0);
            }

            this.props.beginSOP(beginTime, position);
        }
    }

    onClickClose = () => {
        this.props.changeContent('');
    }

    beginEnterKey = () => {
        if (window.event.keyCode === 13) {
            this.onClickBegin();
        }
    }

    onChangeDate = (type, target) => {
        switch (type) {
            case 'year':
                this.setState({ year: Number(target.value) });
                break;
            case 'month':
                this.setState({ month: Number(target.value) });
                break;
            case 'day':
                this.setState({ day: Number(target.value) });
                break;
            case 'hour':
                this.setState({ hour: Number(target.value) });
                break;
            case 'min':
                this.setState({ min: Number(target.value) });
                break;                
        }
        
    }

    render() {
        const [yearTag, monthTag, dayTag, hourTag, minTag] = this.setDateTime();
        return (
            <BeginOptionComponent id={'sopPop'}>
                <div>
                    <div>
                        <div className={'sqPop'}>
                            <div className={'sqpTop'}>
                                <h4>{i18n.t('sopSimulator.formText.시작 이벤트 옵션')}</h4>
                                <p>{this.props.title}</p>
                                <a onClick={() => this.onClickClose()}>{i18n.t('common.닫기')}</a>
                            </div>
                            <div className={'sqpCont'}>
                                <div className={'sqpUp'}>
                                    {
                                        //<select name="" id="" className={uis.sqpSel}>
                                        //    <option value="">선택</option>
                                        //    <option value="">빌딩 1</option>
                                        //</select>
                                        <input type="text" id="txtPosition" className={'sqpSel'} onKeyUp={this.beginEnterKey} placeholder={i18n.t('sopSimulator.formText.시작 위치')} />
                                    }
                                    {
                                        //<div className={uis.sqpChk}>
                                        //    <input type="checkbox" name="sqpChk" id="sqpChk" checked="" /><label htmlFor="sqpChk">상황 시작/종료 문자 메시지 사용</label>
                                        //</div>
                                    }
                                </div>
                                <div className={'sqpDown'}>
                                    
                                        
                                    <ul className={'sqpRdo'}>
                                        <li><input type="radio" name="sqpRdo" id="sqpRdo01" onChange={() => this.onChangeTimeMode(true)} checked={this.state.isCurrent} /><label htmlFor="sqpRdo01">{i18n.t('sopSimulator.formText.현재 시간을 재난발생시간으로 설정')}</label></li>
                                        <li><input type="radio" name="sqpRdo" id="sqpRdo02" onChange={() => this.onChangeTimeMode(false)} /><label htmlFor="sqpRdo02">{i18n.t('sopSimulator.formText.재난 발생 시간 입력')}</label></li>
                                    </ul>
                                    <ul className={'sqpTime'}>
                                        <li>
                                            <select name="" id="" value={this.state.year||''} onChange={(e) => this.onChangeDate('year', e.target)}>
                                                {yearTag}
                                            </select>
                                        </li>
                                        <li>{i18n.t('common.년')}</li>
                                        <li>
                                            <select name="" id="" value={this.state.month || ''} onChange={(e) => this.onChangeDate('month', e.target)}>
                                                {monthTag}
                                            </select>
                                        </li>
                                        <li>{i18n.t('common.월')}</li>
                                        <li>
                                            <select name="" id="" value={this.state.day || ''} onChange={(e) => this.onChangeDate('day', e.target)}>
                                                {dayTag}
                                            </select>
                                        </li>
                                        <li>{i18n.t('common.일')}</li>
                                        <li>
                                            <select name="" id="" value={this.state.hour || ''} onChange={(e) => this.onChangeDate('hour', e.target)}>
                                                {hourTag}
                                            </select>
                                        </li>
                                        <li>:</li>
                                        <li>
                                            <select name="" id="" value={this.state.min || ''} onChange={(e) => this.onChangeDate('min', e.target)}>
                                                {minTag}
                                            </select>
                                        </li>
                                    </ul> 
                                    
                                    <ul className={'sqpBtn'}>
                                        <li><a className={'bk'} onClick={this.onClickBegin}>{i18n.t('common.시작')}</a></li>
                                        <li><a className={'gry'} onClick={this.onClickClose}>{i18n.t('common.취소')}</a></li>
                                    </ul>
                                </div>
                            </div>{/*<!-- sqpCont -->*/}
                        </div>{/*<!-- sqPop -->*/}
                    </div>
                </div>
            </BeginOptionComponent>
          
        );
    }

}

export default withTranslation()(BeginOption);